import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const item: SxStyleFunc<boolean | undefined> = (isDragging) => ({
  flex: 1,
  opacity: isDragging ? 0.5 : 1,
});
